"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _articles = require("./articles");
Object.keys(_articles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _articles[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _articles[key];
        }
    });
});
var _breadcrumbs = require("./breadcrumbs");
Object.keys(_breadcrumbs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _breadcrumbs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _breadcrumbs[key];
        }
    });
});
var _categories = require("./categories");
Object.keys(_categories).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _categories[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _categories[key];
        }
    });
});
var _categoryPageData = require("./categoryPageData");
Object.keys(_categoryPageData).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _categoryPageData[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _categoryPageData[key];
        }
    });
});
var _description = require("./description");
Object.keys(_description).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _description[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _description[key];
        }
    });
});
